'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _CoveApi = require('../lib/CoveApi');

var _CoveApi2 = _interopRequireDefault(_CoveApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Class for the Payment API
 */
var Payment = function (_CoveAPI) {
  (0, _inherits3.default)(Payment, _CoveAPI);

  /**
   * Creates a new Payment API Client
   * @param {string} host
   * @param {string} environment
   * @param {{accessToken: string, apiKey: string, refreshInterval: number}} auth
   */
  function Payment(host, environment, auth) {
    (0, _classCallCheck3.default)(this, Payment);
    return (0, _possibleConstructorReturn3.default)(this, (Payment.__proto__ || (0, _getPrototypeOf2.default)(Payment)).call(this, host, 'payment/v1', environment, auth));
  }

  (0, _createClass3.default)(Payment, [{
    key: 'purchase',
    value: function purchase(ott, quoteId, amount, paymentDetails) {
      var body = {
        ott: ott,
        quoteId: quoteId,
        amount: amount,
        paymentDetails: paymentDetails
      };

      return this.apiClient.fetch('POST', 'purchase', null, body);
    }
  }, {
    key: 'registerIntent',
    value: function registerIntent(quoteId, paymentMethod) {
      var body = {
        quoteId: quoteId,
        paymentMethod: paymentMethod
      };

      return this.apiClient.fetch('POST', 'register-intent', null, body);
    }
  }, {
    key: 'setupIntent',
    value: function setupIntent(quoteId, paymentMethod) {
      var body = {
        quoteId: quoteId,
        payment_method: paymentMethod
      };

      return this.apiClient.fetch('POST', 'setup-intent', null, body);
    }
  }, {
    key: 'chargeRegisteredCard',
    value: function chargeRegisteredCard(quoteId, amount, paymentDetails) {
      var body = {
        quoteId: quoteId,
        amount: amount,
        paymentDetails: paymentDetails
      };

      return this.apiClient.fetch('POST', 'charge-registered-card', null, body);
    }
  }, {
    key: 'create',
    value: function create(customer_id, amount, transaction_type, payment_method, registered, quote_id, coverage_id, change_id) {
      var body = {
        customer_id: customer_id,
        amount: amount,
        transaction_type: transaction_type,
        payment_method: payment_method,
        registered: registered,
        quote_id: quote_id,
        coverage_id: coverage_id,
        change_id: change_id
      };

      return this.apiClient.fetch('POST', 'create', null, body).then(function (paymentResponse) {
        if (registered) {
          return paymentResponse.payment;
        } else {
          return paymentResponse.payment.url;
        }
      });
    }
  }]);
  return Payment;
}(_CoveApi2.default);

exports.default = Payment;